import _ from 'lodash';
import { createSelector } from 'reselect';

export const get = state => state.customer.customerSearch;
export const getSearchCriteria = state => state.customer.customerSearch.searchCriteria;
export const getSearchResults = state => state.customer.customerSearch.searchResults;
export const isLoading = state => state.customer.customerSearch.isLoading;
export const isVisible = state => state.customer.customerSearch.isVisible;

export const getErrors = createSelector(
    getSearchCriteria,
    errors => _.isEmpty(errors)
);

export const getSearchForm = createSelector(
    getSearchCriteria,
    (searchCriteria, errors) => (change, customerLookup) => {
        if (!searchCriteria) return undefined;

        return _.transform(searchCriteria, (result, value, key) => {
            result[key] = _.assign({}, value, {
                onChange: e => change(key, e.target.value),
                onKeyPress: e => {
                    if (e.charCode === 13)
                        customerLookup();
                }
            });
        }, {});
    }
);